module.exports = __webpack_public_path__ + "static/media/(H)-Prata-07.b5520eaf.jpg";